// @ts-nocheck
import React from 'react';
import { withRouter } from '../../router-compat';
import { inject, observer } from "../../stores/mobx-compat";
import moment from 'moment';

import {
  IconButton, DropdownMenu, MenuItem, MenuSection,
} from '../ui';
import ThemeToggle from '../ui/ThemeToggle';
import {
  BellIcon, HelpIcon, MenuIcon, XIcon,
} from '../ui/icons';

const Crumbs = ({ routeConfigs, pathname }) => {
  const segments = pathname.split('/').filter(Boolean);
  const root = segments[0] || '';
  const cfg = routeConfigs.find((r) => r.path.startsWith(`/${root}`));
  return (
    <div
      className="mov-mono"
      style={{ fontSize: 11, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--mov-ink-mute)' }}
    >
      Movology <span style={{ opacity: 0.4 }}>/</span> <b style={{ color: 'var(--mov-ink)', fontWeight: 500 }}>{cfg?.label || cfg?.name || 'Dashboard'}</b>
    </div>
  );
};

const NotificationMenu = inject('store')(observer(({ store }) => {
  const { notifications, deleteNotification } = store.notifications;
  const list = Object.values(notifications);
  return (
    <DropdownMenu
      align="right"
      width={320}
      trigger={<IconButton icon={BellIcon} ariaLabel="Notifications" badge={list.length > 0} />}
    >
      <MenuSection>Notifications</MenuSection>
      {list.length === 0 && (
        <div className="px-3 py-4 text-[13px] text-mov-ink-mute text-center">No new notifications</div>
      )}
      {list.map((n) => (
        <MenuItem key={n.key} keepOpen>
          <span className="flex items-start gap-2.5">
            <button
              type="button"
              onClick={(e) => { e.stopPropagation(); deleteNotification(n.key); }}
              className="text-mov-ink-mute hover:text-mov-ink shrink-0 mt-0.5"
              style={{ background: 'none', border: 0, padding: 0, cursor: 'pointer' }}
            >
              <XIcon size={12} />
            </button>
            <span className="flex-1 min-w-0">
              <span className="block text-[13px] text-mov-ink">{n.text}</span>
              <span className="block mov-mono text-[10.5px] text-mov-ink-mute mt-1">
                {moment(n.timestamp, 'x').fromNow()}
              </span>
            </span>
          </span>
        </MenuItem>
      ))}
    </DropdownMenu>
  );
}));

const Topbar = ({ store, location, routeConfigs, onMobileMenu }) => {
  const { mobile } = store.ui;
  const { user } = store.auth;
  const isSpoofed = typeof window !== 'undefined' && localStorage.getItem('spoofed') === '1';
  const spoofedName = isSpoofed ? (user.company || user.email || '') : '';

  return (
    <header
      className="flex items-center gap-4 sticky top-0 z-10 bg-mov-paper px-7 h-[var(--mov-topbar-h)]"
      style={{ borderBottom: '1px solid var(--mov-line)' }}
    >
      {mobile && (
        <IconButton icon={MenuIcon} ariaLabel="Menu" onClick={onMobileMenu} />
      )}
      {!mobile && <Crumbs routeConfigs={routeConfigs} pathname={location.pathname} />}
      {isSpoofed && spoofedName && (
        <span
          className="mov-mono"
          style={{
            fontSize: 11, letterSpacing: '0.08em', textTransform: 'uppercase',
            color: 'var(--mov-warn-ink)', background: 'var(--mov-warn-soft)',
            padding: '4px 10px', borderRadius: 999,
          }}
        >
          Spoofing · {spoofedName}
        </span>
      )}
      <div className="ml-auto flex items-center gap-2">
        <ThemeToggle />
        <NotificationMenu />
        <IconButton icon={HelpIcon} ariaLabel="Help" />
      </div>
    </header>
  );
};

export default withRouter(inject('store')(observer(Topbar)));
